import styled from "styled-components";
import Link from "next/link";

const StyledInternalLink = styled(Link)`
  color: inherit;
  text-decoration: none;
`;

export default StyledInternalLink;
